import {
  Alert,
  AlertTitle,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

type Props = {
  reconfigureOpen: boolean;
  handleReconfigureCancel: () => void;
  handleReconfigureProceed: () => void;
};

const ReconfigureConfirmationPopup = ({
  reconfigureOpen,
  handleReconfigureCancel,
  handleReconfigureProceed,
}: Props) => {
  return (
    <>
      <Dialog
        open={reconfigureOpen}
        onClose={handleReconfigureCancel}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 600 }}>Reconfigure</DialogTitle>
        <DialogContent>
          <Alert severity="warning" sx={{ border: "1px solid #ED6C0280", color: "#ED6C02" }}>
            <AlertTitle sx={{ fontWeight: 700 }}>
              PROCEED WITH CAUTION!
            </AlertTitle>
            This operation cannot be reversed and may disrupt your brand&apos;s
            configuration.
            <br />
            Proceed only if you are certain.
          </Alert>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleReconfigureCancel} color="secondary">
            CANCEL
          </Button>
          <Button
            onClick={handleReconfigureProceed}
            variant="contained"
            color="secondary"
            endIcon={<ChevronRightIcon />}
          >
            PROCEED
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ReconfigureConfirmationPopup;
